/**
 * Load Google Charts dependencies.
 */
export async function loadPackages(): Promise<void> {
  await google.charts.load('current', {
    packages: ['gauge', 'corechart', 'line'],
  });
}
